<app-splash></app-splash>

<div class="fondoazul2">
    <br>
    <br>
    <div class="container">
        <p class="p-em text-center p-blanco mb-5">"En la Red de Congregaciones de Hermanas Católicas, creemos que la salud es un derecho humano, no un privilegio. Desde 2024, unimos fuerzas para llevar medicina y esperanza a las familias que el sistema de salud ha olvidado."</p>
        <div class="row">
            <div class="col-sm-12 col-md-4 col-lg-4">
                <img src="assets/img/wfoto01.jpg" height="50" alt="Grupo de personas alrededor de una fuente" class="img-fluid mb-3">
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4">
                <img src="assets/img/wfoto02.jpg" height="50" alt="Grupo de personas en una iglesia" class="img-fluid mb-3">
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4">
                <img src="assets/img/wfoto03.jpg" height="50" alt="Grupo de personas en un salón de clases" class="img-fluid mb-3">
            </div>
        </div>
        <br>
        <br class="my-5">
    </div>
</div>

<app-splash2></app-splash2>

<div class="container">
    <div class="row">
        <div class="col-sm-6 col-md-6 col-lg-6 d-flex justify-content-around">
            <img src="assets/img/01carmelitas.jpg" alt="Logotipo de Carmelitas Misioneras de Santa Teresa" class="img-fluid marco-redondo mb-4">
            <img src="assets/img/02mejif.jpg" alt="Logotipo de Misioneras Eucarísticas de Jesús Infante y Nuestra Señora de Fátima" class="img-fluid marco-redondo mb-4">   
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 d-flex justify-content-around">
            <img src="assets/img/03caridad.jpg" alt="Logotipo de Misionera de la Caridad de María Inmaculada" class="img-fluid marco-redondo mb-4">
            <img src="assets/img/04franciscanas.jpg" alt="Logotipo de Hermanas Franciscanas de la Inmaculada Concepción" class="img-fluid marco-redondo mb-4">
        </div>
    </div>
</div>

<br class="my-3">

<!--
<div id="quienessomos"></div>
<br>
<app-quienessomos></app-quienessomos>

<div id="organigrama"></div>
<br>
<div class="fondosecundario">
    <br>
    <app-organigrama></app-organigrama>
    <br class="mb-4">
</div>

<div id="voluntariado"></div>
<br>
<app-voluntariado></app-voluntariado>

<div id="patrocinios"></div>
<br>
<div class="fondosecundario">
    <br>
    <app-sliderimpacto></app-sliderimpacto>
    <br class="mb-4">
</div>

<div id="formacion"></div>
<br>
<app-formacion></app-formacion>

<br class="my-3">

-->